import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class AttendanceAdjustmentDto {

    @ApiProperty()
    attendaceId: number;

    @ApiProperty()
    employeeId: number;

    @ApiProperty()
    employeeCode: string;

    @ApiProperty()
    employeeName: string;

    @ApiProperty()
    date: string;

    @ApiProperty()
    oldInTime: Date;

    @ApiProperty()
    inTime: Date;

    @ApiProperty()
    oldOutTime: Date;

    @ApiProperty()
    outTime: Date;

    @ApiProperty()
    presentStatus: string;

    @ApiProperty()
    departmentId: number;

    @ApiProperty()
    shiftGroup: string;

    @ApiProperty()
    unitId: number;

    @ApiProperty()
    shift: string;

    @ApiProperty()
    reason: string;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    appliedDate: Date;

    @ApiProperty()
    status: LeaveApprovalStatusEnum;

    constructor(
        attendaceId: number, employeeId: number, employeeCode: string, employeeName: string, date: string, oldInTime: Date, inTime: Date, oldOutTime: Date, outTime: Date, presentStatus: string, departmentId: number, shiftGroup: string, unitId: number, shift: string, reason: string, remarks: string, appliedDate: Date, status: LeaveApprovalStatusEnum
    ) {
        this.attendaceId = attendaceId;
        this.employeeId = employeeId;
        this.employeeCode = employeeCode;
        this.employeeName = employeeName;
        this.date = date;
        this.oldInTime = oldInTime;
        this.inTime = inTime;
        this.oldOutTime = oldOutTime;
        this.outTime = outTime;
        this.presentStatus = presentStatus;
        this.departmentId = departmentId;
        this.shiftGroup = shiftGroup;
        this.unitId = unitId;
        this.shift = shift;
        this.reason = reason;
        this.remarks = remarks;
        this.appliedDate = appliedDate;
        this.status = status;
    }


}